import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconKeyboardArrowUpLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m12 10.454-4.073 4.073a.726.726 0 0 1-.522.213.708.708 0 0 1-.532-.213.718.718 0 0 1-.217-.527c0-.206.072-.382.217-.527l4.494-4.494A.868.868 0 0 1 12 8.708a.87.87 0 0 1 .633.27l4.494 4.495c.138.138.21.313.213.522a.707.707 0 0 1-.213.532.718.718 0 0 1-.527.217.718.718 0 0 1-.527-.217L12 10.454Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconKeyboardArrowUpLine;
